import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

/**
 * PostTypeSelector Component
 * Handles selection between single post and thread modes
 * Following PostDetailsModal.js clean structure patterns
 */
const PostTypeSelector = ({ 
    postType, 
    onPostTypeChange, 
    hasThreadCapableAccounts,
    threadSupportedAccounts 
}) => {
    const handleChange = (event, newType) => {
        if (newType !== null) {
            onPostTypeChange(newType);
        }
    };

    return (
        <Box sx={{ mb: 3 }}>
            <ToggleButtonGroup
                value={postType}
                exclusive
                onChange={handleChange}
                aria-label="post type"
                size="small"
            >
                <ToggleButton value="single" aria-label="single post">
                    Single Post
                </ToggleButton>
                <ToggleButton 
                    value="thread" 
                    aria-label="thread"
                    disabled={!hasThreadCapableAccounts}
                >
                    Thread
                </ToggleButton>
            </ToggleButtonGroup>
            
            {/* Warning Messages */}
            {postType === 'thread' && !hasThreadCapableAccounts && (
                <Box 
                    role="alert"
                    aria-live="polite"
                    sx={{
                        backgroundColor: 'error.light',
                        color: 'error.contrastText',
                        p: 2,
                        mt: 2,
                        mb: 1,
                        borderRadius: 2,
                        border: 1,
                        borderColor: 'error.main',
                        boxShadow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <Typography variant="body2" display="block" fontWeight="medium">
                        ⚠️ Thread mode requires X (Twitter) or BlueSky accounts. Please connect a Twitter or BlueSky account to create threads.
                    </Typography>
                </Box>
            )}
            
            {postType === 'thread' && hasThreadCapableAccounts && threadSupportedAccounts.length === 0 && (
                <Box 
                    role="alert"
                    aria-live="polite"
                    sx={{
                        backgroundColor: 'warning.light',
                        color: 'warning.contrastText',
                        p: 2,
                        mt: 2,
                        mb: 1,
                        borderRadius: 2,
                        border: 1,
                        borderColor: 'warning.main',
                        boxShadow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <Typography variant="body2" display="block" fontWeight="medium">
                        💡 Please select X (Twitter) or BlueSky accounts to create threads.
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default PostTypeSelector; 